module.exports = __webpack_public_path__ + "img/results-img@2x.daf99913.png";